import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import atoms from "../../../atoms";
import molecules from "../../../molecules";
import constant from "../../../../constants/constant";
import { ProductDetail, ApproveProductProps } from "../interface";
import { FiEdit } from "react-icons/fi";
import moment from "moment";
import { AiOutlineEye } from "react-icons/ai";
import ThreeDots from "../../../../assets/Images/threeDots.svg";
import { currencySymbol, priceTagFormatter } from "../../../../constants/utils";
import { ProductFilterMobileUI, ProductFilterModule } from "./components";
const { Table, Image, Pagination, CustomImages } = atoms;
const { SidePopUp, ProductFilter,ConfirmationModal } = molecules;
const Index: React.FC<ApproveProductProps> = ({
  productResponse,
  isRecognize,
  setLimitPerPage,
  currentPage,
  setCurrentPage,
  setSearch,
  limit,
  productDetail,
  getDetailById,
  updateVerificationStatus,
  setIsContactLensProduct,
  isContactLensProduct,
  showFilter,
  setShowFilter,
  brandList,
  productTypeList,
  handleChange,
  filterData,
  setProductID,
  handleEcommerceStatus
}) => {
  const navigate = useNavigate();
  const inputRef: any = useRef();
  const [showSidebarModal, setShowSidebarModal] = useState(false);
  const [clickedBrandCategory, setClickedBrandCategory] = useState<any>();
  const [changeOfflineStatus, setChangeOfflineStatus] = useState<boolean>(false)

  const columns = [
    {
      name: "Brand",
      selector: (row: ProductDetail) => row.brand.brand_name,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Date",
      selector: (row: any) =>
        row?.updatedAt ? moment(row?.updatedAt).format("DD/MM/YYYY") : "-",
    },
    {
      name: "Product ID",
      selector: (row: ProductDetail) => `${row.product_id_display}`,
      minWidth: "15%",
    },
    {
      name: "Cover Photo",
      cell: (row: any) => (
        <CustomImages
          src={row?.images?.length > 0 && row?.images[0]}
          imageHeight={"0px"}
        />
      ),
      center: true,
    },
    {
      name: "Model No.",
      selector: (row: ProductDetail) => `${row.modal_number}`,
    },
    {
      name: "Product Type",
      selector: (row: ProductDetail) => row.product_type.name,
    },
    {
      name: `Product SRP (${currencySymbol()})`,
      selector: (row: ProductDetail) =>
        `${row.product_srp !== null ? priceTagFormatter(row?.product_srp) : "-"
        }`,
    },
    { name: "Status", selector: (row: ProductDetail) => row.isActive },
    // {
    //   name: "Verification Status",
    //   selector: (row: ProductDetail) => row.verification_status,
    // },
    {
      name: "Ecommerce Status",
      selector: (row: any) => row?.ecommerceStatus,
    },
    { name: "Action", selector: (row: any) => row.action },
  ];

  const columnsForContactLens = [
    {
      name: "Brand",
      selector: (row: ProductDetail) => row.brand.brand_name,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Date",
      selector: (row: any) =>
        row?.createdAt ? moment(row?.createdAt).format("DD/MM/YYYY") : "-",
    },
    {
      name: "Product ID",
      selector: (row: ProductDetail) => `${row.product_id_display}`,
      minWidth: "15%",
    },
    {
      name: "Cover Photo",
      cell: (row: any) => (
        <CustomImages
          src={row?.images?.length > 0 && row?.images[0]}
          imageHeight={"0px"}
        />
      ),
      center: true,
    },
    {
      name: "Product Type",
      selector: (row: ProductDetail) => row.product_type.name,
    },
    {
      name: `Product SRP (${currencySymbol()})`,
      selector: (row: ProductDetail) =>
        `${row.product_srp !== null ? priceTagFormatter(row.product_srp) : "-"
        }`,
    },
    { name: "Status", selector: (row: ProductDetail) => row.isActive },
    {
      name: "Ecommerce Status",
      selector: (row: any) => row?.ecommerceStatus,
    },
    // {
    //   name: "Verification Status",
    //   selector: (row: ProductDetail) => row.verification_status,
    // },
    { name: "Action", selector: (row: any) => row.action },
  ];

  useEffect(() => {
    if (inputRef?.current) {
      inputRef.current.value = "";
    }
  }, [isRecognize, isContactLensProduct]);
  const handleLensTypeChange = (value: boolean) => {
    setCurrentPage(1);
    setSearch("");
    setIsContactLensProduct(value);
  };
  return (
    <>
      <ProductFilterModule
        inputRef={inputRef}
        setCurrentPage={setCurrentPage}
        setSearch={setSearch}
        isContactLensProduct={isContactLensProduct}
        handleLensTypeChange={handleLensTypeChange}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        isRecognize={isRecognize}
        navigate={navigate}
        filterData={filterData}
        brandList={brandList}
        handleChange={handleChange}
        productTypeList={productTypeList}
      />
      <div>
        <Table
          columns={isContactLensProduct ? columnsForContactLens : columns}
          AdditionalClassName="data-table-container"
          data={productResponse?.data?.map(
            (item: ProductDetail, index: number) => {
              return {
                ...item,
                isActive: item.isActive ? (
                  <div className="background-light-green border-product-radius">
                    <p className="color-green m-1 p-1">
                      {constant.STATUS.ACTIVE}
                    </p>
                  </div>
                ) : (
                  <div className="background-light-red border-product-radius">
                    <p className="color-red m-1 p-1">
                      {constant.STATUS.DEACTIVE}
                    </p>
                  </div>
                ),
                verification_status:
                  item.verification_status ===
                    constant.VERIFICATION_STATUS.PENDING ? (
                    <div className="background-light-yellow border-product-radius">
                      <p className="color-yellow m-1 p-1">{"Pending"}</p>
                    </div>
                  ) : item.verification_status ===
                    constant.VERIFICATION_STATUS.VERIFIED ? (
                    <div className="background-light-green border-product-radius">
                      <p className="color-green m-1 p-1">{"Verified"}</p>
                    </div>
                  ) : item.verification_status ===
                    constant.VERIFICATION_STATUS.REWORK ? (
                    <div className="background-light-red border-product-radius">
                      <p className="color-red m-1 p-1">{"Rejected"}</p>
                    </div>
                  ) : (
                    ""
                  ),
                action: (
                  <>
                    {" "}
                    <div className="table-data-width">
                      <button
                        className="btn dropdown-dots shadow-none action-button"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <Image src={ThreeDots} />
                      </button>
                      <ul
                        className="dropdown-menu dropdown-menu-end dropdown-style"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          {/* {item.verification_status === constant.VERIFICATION_STATUS.VERIFIED ? ( */}
                          <button
                            className="dropdown-item dropdown-item-size"
                            onClick={() => {
                              getDetailById(item.id);
                              setClickedBrandCategory(
                                item?.brand?.brand_category
                              );
                              setShowSidebarModal(true);
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <AiOutlineEye />
                              <span className="ms-2 mb-0">View</span>
                            </div>
                          </button>
                        </li>

                        {/* ) : ( */}
                        {!isRecognize && (
                          <>
                            <li>
                              <hr className="my-1"></hr>
                            </li>
                            <li>
                              <button
                                className="dropdown-item dropdown-item-size"
                                onClick={() =>
                                  navigate(
                                    `/product/edit/${item.id}?isRecognize=${isRecognize
                                      ? constant.BRAND_CATEGORY[0].value
                                      : constant.BRAND_CATEGORY[1].value
                                    }`
                                  )
                                }
                              >
                                <div className="d-flex align-items-center">
                                  <FiEdit />
                                  <span className="ms-2 mb-0">Edit</span>
                                </div>
                              </button>
                            </li>
                          </>
                        )}

                        {/* ) : ( */}
                        {
                          <>
                            <li>
                              <hr className="my-1"></hr>
                            </li>
                            <li>
                              <button
                                className="dropdown-item dropdown-item-size"
                                onClick={() =>
                                  navigate(
                                    `/product/edit/${item.id
                                    }?isDuplicate=${true}&isRecognize=${isRecognize
                                      ? constant.BRAND_CATEGORY[0].value
                                      : constant.BRAND_CATEGORY[1].value
                                    }`
                                  )
                                }
                              >
                                <div className="d-flex align-items-center">
                                  <FiEdit />
                                  <span className="ms-2 mb-0">Duplicate</span>
                                </div>
                              </button>
                              {/* )} */}
                            </li>
                          </>
                        }
                        {/* ) : ( */}
                        {
                          <>
                            <li>
                              <hr className="my-1"></hr>
                            </li>
                            <li>
                              <button
                                className="dropdown-item dropdown-item-size"
                                onClick={() => {
                                  setProductID && setProductID(item.id);
                                  setChangeOfflineStatus(!changeOfflineStatus);
                                }
                                }
                              >
                                <div className="d-flex align-items-center">
                                  <FiEdit />
                                  <span className="ms-2 mb-0">{item.ecommerce_status === constant.ECOMMERCE_STATUS[0].value ? "Offline" : "Online"}</span>
                                </div>
                              </button>
                            </li>
                          </>
                        }
                      </ul>
                    </div>
                  </>
                ),
                ecommerceStatus:
                item.ecommerce_status ===
                    constant.ECOMMERCE_STATUS[1].value ? (
                    <div className="background-light-yellow border-product-radius">
                        <p className="color-yellow m-1 p-1">{"Offline"}</p>
                    </div>
                ) : item.ecommerce_status ===
                    constant.ECOMMERCE_STATUS[0].value ? (
                    <div className="background-light-green border-product-radius">
                        <p className="color-green m-1 p-1">{"Online"}</p>
                    </div>
                ) : (
                    ""
                ),
              };
            }
          )}
        />
      </div>
      <div>
        <Pagination
          totalCount={productResponse?.count}
          currentPage={currentPage}
          totalPages={productResponse?.totalPages}
          onChangePage={(page: any) => setCurrentPage(page)}
          setLimit={(e: number) => {
            setCurrentPage(1);
            setLimitPerPage(e);
          }}
          limit={limit}
        />
      </div>
      {showSidebarModal && (
        <div>
          <SidePopUp
            show={showSidebarModal}
            onHide={() => setShowSidebarModal(false)}
            productDetail={productDetail}
            showImage={(imageUrl: any, index: any) => console.error("error")}
            updateVerificationStatus={(id: string, status: number) =>
              updateVerificationStatus(id, status)
            }
            isBrandedCategory={
              clickedBrandCategory === constant.BRAND_CATEGORY[0].value
            }
          />
        </div>
      )}
      {showFilter && (
        <ProductFilter
          show={showFilter}
          header="Filter"
          onHide={() => setShowFilter(!showFilter)}
          buttonDisable={false}
          handleSubmit={() => setShowFilter(!showFilter)}
          submitBtnText="Apply"
        >
          <ProductFilterMobileUI
            brandList={brandList}
            productTypeList={productTypeList}
            handleChange={handleChange}
            filterData={filterData}
            isContactLensProduct={isContactLensProduct}
          />
        </ProductFilter>
      )}
      {/* offline and online status confirm popup */}
      {changeOfflineStatus && (
        <ConfirmationModal
          show={changeOfflineStatus}
          handleConfirmItem={() => {
            handleEcommerceStatus && handleEcommerceStatus();
            setChangeOfflineStatus(!changeOfflineStatus);
            setCurrentPage(1)
          }}
          onHide={() => setChangeOfflineStatus(!changeOfflineStatus)}
          message={"change this product e-commerce status"}
        />
      )}
      {/* end */}
    </>
  );
};
export default Index;
